import { styled } from '@volkswagen-onehub/components-core';

export const EditEmailAddressCTAContainerStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 8px;

  button:hover svg path {
    fill: currentColor;
  }
`;
